/**
 * Maps API completion flags to UI copy: true = Completed, false = In progress.
 * Supports boolean, string "true"/"false", and optional `statusBoolean` from admin report rows.
 */
export function completionStatusLabel(
  value: unknown,
  statusBoolean?: unknown,
): string {
  if (typeof statusBoolean === "boolean") {
    return statusBoolean ? "Completed" : "In progress";
  }
  if (value === true) return "Completed";
  if (value === false) return "In progress";
  const s = String(value ?? "").trim().toLowerCase();
  if (s === "true" || s === "1") return "Completed";
  if (s === "false" || s === "0") return "In progress";
  if (s === "completed") return "Completed";
  if (s === "in progress" || s === "in_progress" || s === "inprogress") {
    return "In progress";
  }
  if (s === "" || value == null) return "—";
  return String(value).trim() || "—";
}
